/* Cygnus Atratus — global dark mode triggered by founder quote */
(function () {
  var trigger = document.querySelector('.founder-quote');
  if (!trigger) return;

  var targets = [].slice.call(document.querySelectorAll('.shopify-section.section > div'));
  if (!targets.length) return;

  var FROM = [255, 255, 255];
  var TO = [23, 23, 23];

  var TEXT_COLOR = '#d4d4d4';
  var DARK_BG = 'rgb(23,23,23)';

  function ease(t) {
    return t < 0.5
      ? 4 * t * t * t
      : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function mix(from, to, progress) {
    return [
      Math.round(from[0] + (to[0] - from[0]) * progress),
      Math.round(from[1] + (to[1] - from[1]) * progress),
      Math.round(from[2] + (to[2] - from[2]) * progress)
    ];
  }

  function rgb(arr) {
    return 'rgb(' + arr[0] + ',' + arr[1] + ',' + arr[2] + ')';
  }

  function setTextColor(container, active) {
    var color = active ? TEXT_COLOR : '';

    container.style.setProperty('color', color, 'important');

    container.querySelectorAll('*').forEach(function (el) {
      el.style.setProperty('color', color, 'important');

      if (el.tagName && el.tagName.toLowerCase() === 'svg') {
        el.style.setProperty('fill', color, 'important');
        el.style.setProperty('stroke', color, 'important');
      }

      if (el.closest && el.closest('svg')) {
        el.style.setProperty('fill', color, 'important');
        el.style.setProperty('stroke', color, 'important');
      }
    });
  }

  function getProgress() {
    var vh = window.innerHeight || 800;
    var rect = trigger.getBoundingClientRect();

    var transitionZone = vh * 0.4;

    var progress = (vh - (rect.top + 200)) / transitionZone;
    progress = Math.max(0, Math.min(1, progress));

    return ease(progress);
  }

  function update() {
    var progress = getProgress();
    var active = progress > 0.02;

    var bg = active ? 'rgb(23,23,23)' : rgb(mix(FROM, TO, progress));

    targets.forEach(function (target) {
      target.style.setProperty('background', bg, 'important');
      target.classList.toggle('ca-global-dark-active', active);
      setTextColor(target, active);
    });

    document.documentElement.classList.toggle('ca-global-dark-active', active);
    document.body.classList.toggle('ca-global-dark-active', active);
  }

  var ticking = false;

  function onScroll() {
    if (ticking) return;

    ticking = true;

    requestAnimationFrame(function () {
      update();
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  document.addEventListener('shopify:section:load', function () {
    targets = [].slice.call(document.querySelectorAll('.shopify-section.section > div'));
    update();
  });

  update();
})();

/* Founder quote reveal animation */
(function () {
  var items = document.querySelectorAll('.founder-quote');
  if (!items.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('ca-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.3
  });

  items.forEach(function (item) {
    observer.observe(item);
  });
})();